import type { ReactNode } from "react";
import {
  Platform,
  ScrollView,
  StyleSheet,
  useWindowDimensions,
  View,
} from "react-native";

import { spacing } from "~/styles/theme";
import { Screen } from "./Screen";
import { WebFooter } from "./WebFooter";

export function ScrollScreen({ children }: { children: ReactNode }) {
  const { width } = useWindowDimensions();
  return (
    <Screen>
      <ScrollView
        contentContainerStyle={[
          stylesheet.content,
          width >= 768 ? stylesheet.wide : null,
          Platform.OS === "web" ? stylesheet.web : null,
        ]}
      >
        <View style={stylesheet.body}>{children}</View>
        <WebFooter />
      </ScrollView>
    </Screen>
  );
}

const stylesheet = StyleSheet.create({
  content: {
    flexGrow: 1,
    width: "100%",
    maxWidth: 1180,
    alignSelf: "center",
    padding: spacing.l,
  },
  wide: { padding: spacing.xl },
  web: { paddingBottom: 0 },
  body: { flexGrow: 1 },
});
